import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface SteeringBarProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function SteeringBar(props: SteeringBarProps) {
  return (
    <svg
      width="82"
      height="300"
      viewBox="0 0 82 300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{top: 101, left: 177}}
      onClick={props.onClick}
    >
      <path
        d="M65.252 275.047L65.9053 274.542C66.7784 273.866 68.0333 274.026 68.708 274.9L71.1514 278.067C71.8261 278.942 71.6652 280.2 70.792 280.876L70.2354 281.307L80 294L75 298L65.1748 285.227L64.4678 285.775C63.5946 286.452 62.3397 286.291 61.665 285.416L59.2217 282.249C58.5472 281.375 58.7081 280.118 59.5811 279.441L60.1914 278.968L7 211C7 211 5.00001 211 5 209C5 207 7 207 7 207H5C5 207 3.00001 207 3 205C3 203 5 203 5 203H3C3 203 1.00001 203 1 201C1 199 3 199 3 199V195C3 195 1 195 1 193V107C1 105 3 105 3 105V101C3 101 1 101 1 99C1.00001 97 3 97 3 97H5C5 97 3 97 3 95C3.00001 93 5 93 5 93H7C7 93 5 93 5 91C5.00001 89 7 89 7 89L60.1914 21.0312L59.5811 20.5586C58.7081 19.8822 58.5472 18.6255 59.2217 17.751L61.665 14.584C62.3397 13.7094 63.5946 13.5482 64.4678 14.2246L65.1748 14.7725L75 2L80 6L70.2354 18.6924L70.792 19.124C71.6652 19.8005 71.8261 21.0581 71.1514 21.9326L68.708 25.0996C68.0333 25.9741 66.7784 26.1344 65.9053 25.458L65.252 24.9521L15 89C15 89 17 89 17 91C17 93 15 93 15 93H17C17 93 19 93 19 95C19 97 17 97 17 97H19C19 97 21 97 21 99C21 101 19 101 19 101V105C19 105 21 105 21 107V193C21 195 19 195 19 195V199C19 199 21 199 21 201C21 203 19 203 19 203H17C17 203 19 203 19 205C19 207 17 207 17 207H15C15 207 17 207 17 209C17 211 15 211 15 211L65.252 275.047Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        opacity="0.1"
        d="M3 105V101H19V105"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        opacity="0.1"
        d="M18.9587 97H3C1.89543 97 1 97.8954 1 99C1 100.105 1.89543 101 3 101H18.9587C20.0632 101 20.9587 100.105 20.9587 99C20.9587 97.8954 20.0632 97 18.9587 97Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        opacity="0.1"
        d="M16.9628 93H4.99586C3.8913 93 2.99586 93.8954 2.99586 95C2.99586 96.1046 3.8913 97 4.99586 97H16.9628C18.0674 97 18.9628 96.1046 18.9628 95C18.9628 93.8954 18.0674 93 16.9628 93Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        opacity="0.1"
        d="M14.9669 89H6.99173C5.88716 89 4.99173 89.8954 4.99173 91C4.99173 92.1046 5.88716 93 6.99173 93H14.9669C16.0715 93 16.9669 92.1046 16.9669 91C16.9669 89.8954 16.0715 89 14.9669 89Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        opacity="0.1"
        d="M59.9276 21.2682L7.0503 89.0918M65.0541 25.3659L15.1679 89.1983"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <rect
        width="12"
        height="8"
        rx="2"
        transform="matrix(0.79054 0.612411 -0.610826 0.791765 62.8866 13)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M69 18L64.5 24"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M15 89H11H7C7 89 5 89 5 91C5 93 7 93 7 93H11H15C15 93 17 93 17 91C17 89 15 89 15 89Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M17 93H11H5C5 93 3 93 3 95C3 97 5 97 5 97H11H17C17 97 19 97 19 95C19 93 17 93 17 93Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M19 97H11H3C3 97 1 97 1 99C1 101 3 101 3 101H11H19C19 101 21 101 21 99C21 97 19 97 19 97Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <rect
        x="3"
        y="101"
        width="16"
        height="4"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M60 21L7 89H15L65 25"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M70 19L80 6L75 2L65 15"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        opacity="0.1"
        d="M3 195V199H19V195"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        opacity="0.1"
        d="M18.9587 203H3C1.89543 203 1 202.105 1 201C1 199.895 1.89543 199 3 199H18.9587C20.0632 199 20.9587 199.895 20.9587 201C20.9587 202.105 20.0632 203 18.9587 203Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        opacity="0.1"
        d="M16.9628 207H4.99586C3.8913 207 2.99586 206.105 2.99586 205C2.99586 203.895 3.8913 203 4.99586 203H16.9628C18.0674 203 18.9628 203.895 18.9628 205C18.9628 206.105 18.0674 207 16.9628 207Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        opacity="0.1"
        d="M14.9669 211H6.99173C5.88716 211 4.99173 210.105 4.99173 209C4.99173 207.895 5.88716 207 6.99173 207H14.9669C16.0715 207 16.9669 207.895 16.9669 209C16.9669 210.105 16.0715 211 14.9669 211Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        opacity="0.1"
        d="M59.9276 278.732L7.0503 210.908M65.0541 274.634L15.1679 210.802"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <rect
        width="12"
        height="8"
        rx="2"
        transform="matrix(0.79054 -0.612411 -0.610826 -0.791765 62.8866 287)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M69 282L64.5 276"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M21 193V150V107C21 105 19 105 19 105H11H3C3 105 1 105 1 107V150V193C1 195 3 195 3 195H11H19C19 195 21 195 21 193Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M5.98967 194.752V150C5.98967 132.523 5.98967 122.725 5.98967 105.248"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M15 211H11H7C7 211 5 211 5 209C5 207 7 207 7 207H11H15C15 207 17 207 17 209C17 211 15 211 15 211Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M17 207H11H5C5 207 3 207 3 205C3 203 5 203 5 203H11H17C17 203 19 203 19 205C19 207 17 207 17 207Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M19 203H11H3C3 203 1 203 1 201C1 199 3 199 3 199H11H19C19 199 21 199 21 201C21 203 19 203 19 203Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <rect
        width="16"
        height="4"
        transform="matrix(1 0 0 -1 3 199)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M60 279L7 211H15L65 275"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M70 281L80 294L75 298L65 285"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
    </svg>
  );
}
